import * as React from "react";

import * as styles from "./card.module.scss";

export const Card: React.FunctionComponent<React.PropsWithChildren<{}>> = ({
  children,
}) => {
  return <div className={styles.card}>{children}</div>;
};
